import {
    AFFILIATE_PARTNER_CREATE_FAIL, 
    AFFILIATE_PARTNER_CREATE_REQUEST,
    AFFILIATE_PARTNER_CREATE_SUCCESS,
    AFFILIATE_PARTNER_GET_FAIL,
    AFFILIATE_PARTNER_GET_REQUEST,
    AFFILIATE_PARTNER_GET_SUCCESS,
    AFFILIATE_PARTNER_LIST_FAIL,
    AFFILIATE_PARTNER_LIST_REQUEST,
    AFFILIATE_PARTNER_LIST_SUCCESS,
    AFFILIATE_PARTNER_UPDATE_FAIL,
    AFFILIATE_PARTNER_UPDATE_REQUEST,
    AFFILIATE_PARTNER_UPDATE_SUCCESS,
} from '../constants/affiliatePartnerConstants'
import api from '../core/api'

export const createAffiliatePartner = (parm) => async (dispatch, getState) => {
    try {
        dispatch({ type: AFFILIATE_PARTNER_CREATE_REQUEST })

        const { data } = await api.post(
            `/affiliatepartner`,
            parm
        )

        var dt = data.Result
        if(dt.includes("Error")){
            dispatch({
                type: AFFILIATE_PARTNER_CREATE_FAIL,
                payload: data.Result.replace('Error - ', '')
            })
        }else{
            dispatch({
                type: AFFILIATE_PARTNER_CREATE_SUCCESS,
                payload: data.Result
            })
        }
    } catch (error) {
        dispatch({
            type: AFFILIATE_PARTNER_CREATE_FAIL,
            payload:
                error.response && error.response.data.message
                    ? error.response.data.message
                    : error.message,
        })
    }
}

export const listAffiliatePartners = () => async (dispatch, getState) => {
    try {
        dispatch({ type: AFFILIATE_PARTNER_LIST_REQUEST })
        const { data } = await api.get(
            "/affiliatepartner"
        )

        var dt = data.Result;
        if(typeof (dt) == 'string'){
            dispatch({
                type: AFFILIATE_PARTNER_LIST_FAIL,
                payload: data.Result
            })
        }else{
            dispatch({
                type: AFFILIATE_PARTNER_LIST_SUCCESS,
                payload: data.Result
            })
        }
        
    } catch (error) {
        dispatch({
            type: AFFILIATE_PARTNER_LIST_FAIL,
            payload:
                error.response && error.response.data.message
                    ? error.response.data.message
                    : error.message,
        })
    }
}

export const getAffiliatePartner = (id) => async (dispatch, getState) => {
    try {
        dispatch({ type: AFFILIATE_PARTNER_GET_REQUEST })
        const { data } = await api.get(
            "/affiliatepartner/" + id
        )

        var dt = data.Result;
        if(typeof (dt) == 'string'){
            dispatch({
                type: AFFILIATE_PARTNER_GET_FAIL,
                payload: data.Result
            })
        }else{
            dispatch({
                type: AFFILIATE_PARTNER_GET_SUCCESS,
                payload: data.Result
            })
        }
        
    } catch (error) {
        dispatch({
            type: AFFILIATE_PARTNER_GET_FAIL,
            payload:
                error.response && error.response.data.message
                    ? error.response.data.message
                    : error.message,
        })
    }
}

export const updateAffiliatePartner = (id, parm) => async (dispatch, getState) => {
    try {
        dispatch({ type: AFFILIATE_PARTNER_UPDATE_REQUEST })
        const { data } = await api.put(
            "/affiliatepartner/" + id,
            parm
        )

        var dt = data.Result
        if(dt.includes("Error")){
            dispatch({
                type: AFFILIATE_PARTNER_UPDATE_FAIL,
                payload: data.Result.replace('Error - ', '')
            })
        }else{
            dispatch({
                type: AFFILIATE_PARTNER_UPDATE_SUCCESS,
                payload: data.Result
            })
        }
    } catch (error) {
        dispatch({
            type: AFFILIATE_PARTNER_UPDATE_FAIL,
            payload:
                error.response && error.response.data.message
                    ? error.response.data.message
                    : error.message,
        })
    }
}